import React from 'react';

import Tooltip from '@prisjakt/ui-tooltip-new';

import * as S from './styles';

type OwnProps = {
  icon: React.ReactElement;
  showTooltip?: boolean;
  tooltipText?: string;
};

const Icon = ({ icon, showTooltip = false, tooltipText }: OwnProps) => {
  return (
    <S.Icon>
      {showTooltip ? (
        <Tooltip placement="top" title={tooltipText} renderOnMouseOver>
          {icon}
        </Tooltip>
      ) : (
        icon
      )}
    </S.Icon>
  );
};

export default Icon;
